/**
 * Enum for all module names used in RouteErrorBoundary within the Admin app.
 */
export enum ModuleName {
  // ─── Auth ──────────────────────────────────────────────────────────────────
  Login = "Login",
  ForgotPassword = "ForgotPassword",
  OtpVerification = "OtpVerification",
  CheckEmailInstruction = "CheckEmailInstruction",
  ResetPassword = "ResetPassword",

  // ─── Private ───────────────────────────────────────────────────────────────
  Dashboard = "Dashboard",
  AdminAccount = "AdminAccount",
  CommissionRules = "CommissionRules",
  AddEditCommissionRules = "AddEditCommissionRules",
  Target = "Target",
  AddEditTarget = "AddEditTarget",
  Partner = "Partner",
  AddEditPartner = "AddEditPartner",
  ViewPartner = "ViewPartner",
  ViewMappedUser = "ViewMappedUser",
  RunPayout = "RunPayout",
  PayoutLog = "PayoutLog",
  SettingPage = "SettingPage",
  MessageCreditConfiguration = "MessageCreditConfiguration",
  TenantSubscription = "TenantSubscription",
  TenantList = "TenantList",
  Coupon = "Coupon",
  AddEditCoupon = "AddEditCoupon",
  ModelWiseConfiguration = "ModelWiseConfiguration",
  ModelWiseConfigForm = "ModelWiseConfigForm",
  WhatsappMessagePrice = "WhatsappMessagePrice",
  WhatsappMessagePriceForm = "WhatsappMessagePriceForm",
  
  EmailConfiguration = "EmailConfiguration",

  StorageConfiguration = "StorageConfiguration",
  GoogleAdsConfiguration = "GoogleAdsConfiguration",
  CouponUsages = "CouponUsages",
  TenantTransaction = "TenantTransaction",
  OfflineRegistration = "OfflineRegistration",
  AddOfflineRegistration = "AddOfflineRegistration",
  ViewOfflineRegistration = "ViewOfflineRegistration",
  Users = "Users",
  RolePermission = "RolePermission",
  AddRolePermission = "AddRolePermission",
  ViewRolePermission = "ViewRolePermission",
  UsersActivities = "UsersActivities",
  Plan = "Plan",
  PlanForm = "PlanForm",
  PaymentLink = "PaymentLink",
  AddViewPaymentLink = "AddViewPaymentLink",
}
